var _style, _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 60,
    viewBox: "0 0 130 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .text { font-family: Arial, sans-serif; font-size: 40px; font-weight: bold; }\n    .accent { fill: #EA5252; }\n    .circle { fill: #EA5252; }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 45,
    className: "text accent"
  }, "D")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 45,
    className: "text",
    fill: "black"
  }, "emy")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e6deb7f2e12dc422e196e1b6f2d1fc7.svg";
export { ForwardRef as ReactComponent };